export enum PositionSimulationSettingsType {
  PlacementSettings = 'PlacementSettings',
  ValidationSettings = 'ValidationSettings'
}
